import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from 'reducers/rootReducer'
import { useCustomTranslation } from 'hooks/useCustomTranslation'
import InnerTitleSection from 'components/InnerTitleSection/InnerTitleSection'
import Map from './Map/Map'
import TitleSection from 'components/TitleSection/TitleSection'
import Loader from 'components/Loader/Loader'

const OurBranches: React.FC = () => {
  const { t, i18n } = useCustomTranslation()
  const currentLanguage = i18n.language
  const isAr = currentLanguage === 'ar'

  const isLoading = useSelector((state: RootState) => state.branches.isLoading)

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return isLoading ? (
    <Loader />
  ) : (
    <main>
      <InnerTitleSection
        title={t('navOurBranches')}
        breadcrumbs={[
          {
            title: t('navHome'),
            link: '/',
          },
          {
            title: t('navOurBranches'),
          },
        ]}
      />
      <div className='mt-5'>
        <TitleSection title={t('leagueBranches')} customPadding />
      </div>
      <Map isAr={isAr} t={t} />
    </main>
  )
}

export default OurBranches
